import { Provider } from "jotai";
import ReactDOM from "react-dom/client";
import { logger } from "@NBCUDTC/reactjs-utility-belt/logger";

import "./styles/global.scss";
import { App } from "./components/ecosystems/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider>
    <App />
  </Provider>,
);

// Register service worker with automatic updates
serviceWorkerRegistration.register({
  onUpdate: () => {
    logger.info(
      "[PWA] New version available! Will activate on next app restart.",
    );
    // Update will activate automatically when user closes and reopens the app
  },
  onSuccess: () => {
    logger.info("[PWA] Content cached for offline use.");
  },
});
